<template>
  <div class="newViolation">
    <v-card class="pa-10" flat>
      <v-card-title class="pa-0">
        {{ $route.name == 'ChatNewViolation' ? '新增違規' : '更新違規' }}
      </v-card-title>
      <v-divider class="mb-5"></v-divider>
      
      <v-row>
        <v-col>
          <v-subheader></v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            :rules="[$rules.notEmpty]"
          ></v-text-field>
        </v-col>
      </v-row>



      <v-row class="mt-6">
        <v-btn block dark color="indigo" @click="submit">送出</v-btn>
      </v-row>

    </v-card>
  </div>    
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {

    }
  },
  created() {
    if(this.updating) {
      this.getViolation()
    }
  },
  computed: {
    updating() {
      return this.$route.name == 'ChatEditViolation'
    },
    formIsValid() {
      return {}
    },
  },
  methods: {
    getViolation() {

    },
    submit() {

    }
  }
}
</script>

<style lang="scss">
.newViolation {
  .row {
    align-items: center;
    & > div:first-child {
      flex-grow: 0;
      min-width: 140px;
    }
    & > div:nth-child(2) {
      max-width: 800px;
    }
  }
  .v-subheader {
    white-space: nowrap;
  }
}
</style>